import React, { useContext } from 'react';
import Modal from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import Load from 'components/Load';
import { color } from 'styles/pallete';
import { UseTranslationProps } from 'types/UseTranslationProps';
import LoadGeneralContext from 'context/LoadGeneralContext';

export default function LoadGeneral() {
	const { t }: UseTranslationProps = useTranslation();
	const {
		isOpenLoad,
		message,
		color: backgroundColor
	} = useContext(LoadGeneralContext);

	return (
		<Modal open={isOpenLoad}>
			<S.container $colorDivBackground={backgroundColor}>
				<Load colorBackgound={color.system.success} />
				{message !== '' && (
					<S.notice $colorFont={backgroundColor}>{t(message)}</S.notice>
				)}
			</S.container>
		</Modal>
	);
}
